import { useIsMutating } from 'query';

import { mutations } from './queryKeyFactory';

export const useIsUpdating = () => useIsMutating(mutations.getPath()) > 0;
